import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Collapse, IconButton, Paper } from "@mui/material";
import { Tab, Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { HStack, Spacer, VStack } from "Components/LabIZO/Stackizo";
import { Authority, ColorX } from "static";
import _ from "lodash";
import { useEffect, useState } from "react";
import tabs from "./tabs";

const Chat = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [addOns, setAddOns] = useState({});
  const [showSettings, setShowSettings] = useState(true);
  const [showDetails, setShowDetails] = useState(true);

  const renderSettingsArrow = () => {
    return (
      <IconButton sx={{ position: "relative" }} onClick={() => setShowSettings(!showSettings)}>
        {showSettings ? <ArrowBackIos sx={{ color: "primary.main" }} /> : <ArrowForwardIos sx={{ color: "primary.main" }} />}
      </IconButton>
    );
  };
  const renderDetailsArrow = () => {
    return (
      <IconButton sx={{ position: "relative" }} onClick={() => setShowDetails(!showDetails)}>
        {showDetails ? <ArrowBackIos sx={{ color: "primary.main" }} /> : <ArrowForwardIos sx={{ color: "primary.main" }} />}
      </IconButton>
    );
  };

  const renderTabPanels = () => {
    const preLoad = false;
    let tabsAllowed = tabs.filter((o: any) => o.reqAuth === "None" || Authority.IsAccessibleQ(o.reqAuth, o.reqLevel, o.reqFunc));
    return _.map(tabsAllowed, (o, i) => {
      if (!preLoad && selectedTab !== i) return <Box key={i} />;

      return (
        <HStack sx={{ mt: "50px", width: "calc(100%)", height: "calc(100% - 50px)", display: "flex", justifyContent: "center", alignContent: "center" }} gap={1}>
          {o.showSetting && renderSettingsArrow()}
          {_.isFunction(o.settingComponent) ? (
            <Paper sx={{ width: "100%", maxWidth: "300px", height: "100%", p: 2, display: showSettings ? "flex" : "none" }}>{o.settingComponent(addOns, setAddOns)}</Paper>
          ) : null}

          <Paper sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}>
            <VStack key={i} hidden={selectedTab !== i} sx={{ width: "100%", height: "100%", maxWidth: "600px" }}>
              {_.isFunction(o.render) ? o.render(addOns, setAddOns) : o.render}
            </VStack>
          </Paper>

          {o.showDetails && renderDetailsArrow()}
          {_.isFunction(o.detailsComponent) ? <Paper sx={{ width: "100%", height: "100%", p: 0, display: showDetails ? "flex" : "none" }}>{o.detailsComponent(addOns, setAddOns)}</Paper> : null}
        </HStack>
      );
    });
  };

  const renderTabButtons = () => {
    let tabsAllowed = tabs.filter((o: any) => o.reqAuth === "None" || Authority.IsAccessibleQ(o.reqAuth, o.reqLevel, o.reqFunc));

    return _.map(tabsAllowed, (o: any, i) => {
      let label = o.label;
      let icon = o.icon;
      if (o.noTransform) {
        label = <Typography style={{ height: "100%", textTransform: "none" }}>{o.label}</Typography>;
      }
      switch (o.iconPos) {
        case "top":
        default:
          break;
        case "bottom":
          label = (
            <VStack gap={o.spacing || 5}>
              {label}
              {icon}
            </VStack>
          );
          icon = null;
          break;
        case "left":
          label = (
            <HStack gap={o.spacing || 5}>
              {o.alignment === "right" && <Spacer />}
              {icon}
              {label}
              {o.alignment === "left" && <Spacer />}
            </HStack>
          );
          icon = null;
          break;
        case "right":
          label = (
            <HStack gap={o.spacing || 5}>
              {o.alignment === "right" && <Spacer />}
              {label}
              {icon}
              {o.alignment === "left" && <Spacer />}
            </HStack>
          );
          icon = null;
          break;
      }
      return <Tab key={i} label={label} icon={icon} disabled={o.disabled} style={{ color: ColorX.GetColorCSS("Primary"), minHeight: o.height || "100%", minWidth: o.width || 200 }} />;
    });
  };

  const onChangeTab = (e: any, tab: any) => {
    setSelectedTab(tab);
  };

  const themeColor = ColorX.GetColorCSS("Primary");

  return (
    <VStack className="TestChat" width="calc(100vw - 40px)" sx={{ background: "#f0f8ff" }}>
      <VStack className={"centre"} style={{ width: "100%", minHeight: "100%", height: "100%" }}>
        <Paper style={{ width: "100%", zIndex: 3, position: "fixed" }}>
          <Tabs
            TabIndicatorProps={{ style: { background: ColorX.GetColorCSS("Primary") } }}
            value={selectedTab}
            onChange={onChangeTab}
            sx={{ backgroundColor: ColorX.GetColorCSS("Secondary"), color: themeColor, height: "50px" }}
            variant="scrollable"
            scrollButtons={"auto"}
            allowScrollButtonsMobile={true}
          >
            {renderTabButtons()}
          </Tabs>
        </Paper>
        {renderTabPanels()}
      </VStack>
    </VStack>
  );
};
export default Chat;
